import { IconProps } from "@tfg/ui"

export const IconDyeing = ({ size = 24, ...props }: IconProps) => (
  <svg
    id="dyeing_svg__Calque_1"
    xmlns="http://www.w3.org/2000/svg"
    x={0}
    y={0}
    viewBox="0 0 44 44"
    xmlSpace="preserve"
    width={size}
    height={size}
    {...props}
  >
    <style>
      {".dyeing_svg__st0{fill:none;stroke:currentColor;stroke-width:2}"}
    </style>
    <path
      className="dyeing_svg__st0"
      d="M6.7 21.9h21M17.5 10.2l11 11-10.3 10.2c-.8.8-2.1.8-2.9 0l-8.1-8.1c-.8-.8-.8-2.1 0-2.9l10.3-10.2z"
    />
    <path
      d="m17.2 9.9-2-2.2"
      style={{
        fill: "none",
        stroke: "currentColor",
        strokeWidth: 2,
        strokeLinecap: "round",
      }}
    />
    <path
      d="M30.6 30.6c-.3.5-.5 1.2-.5 1.8 0 .6.2 1.3.5 1.8s.8 1 1.3 1.3c.5.3 1.2.5 1.8.5s1.3-.2 1.8-.5 1-.8 1.3-1.3c.3-.5.5-1.2.5-1.8 0-.6-.2-1.3-.5-1.8l-3.1-4.8-3.1 4.8h0z"
      style={{
        fill: "none",
        stroke: "currentColor",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round",
      }}
    />
  </svg>
)
